import React from 'react';
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';
import Rodal from '../../components/Rodal/Rodal';
import './VideoPlayerPopup.scss';
import { ModalBody, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

interface VideoPlayerPopupProps {
    title: string;
    src: string;
    isHls?: boolean;
    onClose(): void;
    isRecordingEnabled: boolean;
    completeRecording?: (startTime: number, endTime: number) => void;
    startTimeSeconds?: number;
    endTimeSeconds?: number;
    hideContextMenu?: boolean;
    downloadUrl?: string;
}

export const VideoPlayerPopup = (props: VideoPlayerPopupProps) => {
    return (
        <div className="video-player-popup">
            <Rodal
                showMask={true}
                width={1000}
                visible={true}
                animation={'slideRight'}
                onClose={() => props.onClose()}
                closeMaskOnClick={false}
                center>
                <ModalHeader>
                    {props.title}
                    {props.downloadUrl && (
                        <FontAwesomeIcon
                            icon={faDownload}
                            className="ml-2 cursor-pointer"
                            onClick={() => window.open(props.downloadUrl, '_blank')}
                        />
                    )}
                </ModalHeader>
                <ModalBody>
                    <VideoPlayer
                        videoSource={props.src}
                        isHls={props.isHls}
                        isRecordingEnabled={props.isRecordingEnabled}
                        completeRecording={props.completeRecording}
                        startTimeSeconds={props.startTimeSeconds}
                        endTimeSeconds={props.endTimeSeconds}
                        hideContextMenu={props.hideContextMenu || false}></VideoPlayer>
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default VideoPlayerPopup;
